// extracted by mini-css-extract-plugin
export default {"openLetterContent":"styles_openLetterContent__r0Y8C","previewButton":"styles_previewButton__VUJqE","names":"styles_names__o9Zpb"};